
import request from "../utils/request"
export function list(data) {//渠道选项
    return request({
        url:'/service/mg/follower/user/buyerId',
        method:'post',
        data
    })
}

export function join(data) {//加入essaone
    return request({
        url:'/service/mg/follower/user/buyerId/do-apply-essaone-platform',
        method:'post',
        data
    })
}